import { Stack, useLocalSearchParams, useNavigation } from 'expo-router';
import {
  flowNameAttributes,
  PUSH_TO_CARD_TRANSFER_TYPE,
} from 'features/feeBasedInstantTransfer/helpers/analyticsFormatters';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { navigateBack } from 'shared/helpers/backNavigation.helpers';
import usePreventBackNavigation from 'shared/hooks/usePreventBackNavigation/usePreventBackNavigation';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';

const PROCESSING_ATTRIBUTES = { transfer_type: PUSH_TO_CARD_TRANSFER_TYPE };

function TransferProcessingScreen() {
  const { t } = useTranslation('feeBasedInstantTransfer');
  const navigation = useNavigation();
  const { flowName } = useLocalSearchParams<{ flowName?: string }>();
  const flowAttributes = flowNameAttributes(flowName);
  const isLeavingRef = useRef(false);
  usePreventBackNavigation(true, (action) => {
    if (isLeavingRef.current) {
      navigation.dispatch(action);
    }
  });

  const handleDone = () => {
    isLeavingRef.current = true;
    navigateBack();
  };

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <SuccessScreen
        visual="HOURGLASS_A"
        screenAnalyticsEventKey="instantTransferProcessing"
        customAttributes={{ ...PROCESSING_ATTRIBUTES, ...flowAttributes }}
        titleText={t('processing.title')}
        content={
          <BodyBaseText numberOfLines={0} style={styles.message}>
            {t('processing.message')}
          </BodyBaseText>
        }
        primaryButton={{
          label: t('processing.done'),
          onPress: handleDone,
          analyticsId: 'transferMoneyProcessingDone',
          customAttributes: flowAttributes,
        }}
      />
    </>
  );
}

const styles = StyleSheet.create({
  message: { textAlign: 'center' },
});

export default TransferProcessingScreen;
